import { render, staticRenderFns } from "./AdminPanelStats.vue?vue&type=template&id=3cdab067&scoped=true&"
import script from "./AdminPanelStats.vue?vue&type=script&lang=js&"
export * from "./AdminPanelStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdab067",
  null
  
)

export default component.exports